import React from 'react';

const CameraIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0001 22.8001C20.651 22.8001 22.8001 20.651 22.8001 18.0001C22.8001 15.3491 20.651 13.2001 18.0001 13.2001C15.3491 13.2001 13.2001 15.3491 13.2001 18.0001C13.2001 20.651 15.3491 22.8001 18.0001 22.8001Z"
        fill="#858585"
      />
      <path
        d="M13.5 3L10.755 6H6C4.35 6 3 7.35 3 9V27C3 28.65 4.35 30 6 30H30C31.65 30 33 28.65 33 27V9C33 7.35 31.65 6 30 6H25.245L22.5 3H13.5ZM18 25.5C13.86 25.5 10.5 22.14 10.5 18C10.5 13.86 13.86 10.5 18 10.5C22.14 10.5 25.5 13.86 25.5 18C25.5 22.14 22.14 25.5 18 25.5Z"
        fill="#858585"
      />
    </svg>
  );
};

export default CameraIcon;
